import React from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import type { TransitionProposal } from "@fartherfinance/frontend/api/TransitionProposals/types";

import { ActionMenuItem, MenuActions } from "../types";
import IconButton from "@src/sharedComponents/IconButton/IconButton";
import Menu from "@src/sharedComponents/Menu/Menu";

interface Props {
  onClick: (action: MenuActions, proposal: TransitionProposal) => void;
  proposal: TransitionProposal;
}

export const TransitionProposalActionMenu: React.FC<Props> = ({
  onClick,
  proposal,
}) => {
  const handleOnClickAction =
    (action: ActionMenuItem["value"], proposal: TransitionProposal) =>
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      return onClick(action, proposal);
    };

  const menuItems: ActionMenuItem[] = [
    {
      label: "Share Proposal",
      value: MenuActions.Share,
      onClick: handleOnClickAction(MenuActions.Share, proposal),
      isCloseOnClick: true,
      isDisabled:
        proposal.proposedPortfolioPlanId !== null ||
        proposal.status !== "processing",
    },
    {
      label: "Rename Proposal",
      value: MenuActions.Rename,
      isCloseOnClick: true,
      onClick: handleOnClickAction(MenuActions.Rename, proposal),
    },
    {
      label: "Duplicate",
      value: MenuActions.Duplicate,
      isCloseOnClick: true,
      onClick: handleOnClickAction(MenuActions.Duplicate, proposal),
    },
    {
      label: "Delete",
      value: MenuActions.Delete,
      onClick: handleOnClickAction(MenuActions.Delete, proposal),
      isCloseOnClick: true,
      textColor: "textDanger",
    },
  ];

  return (
    <Menu
      anchorOrigin={{ horizontal: "left", vertical: "top" }}
      transformOrigin={{ horizontal: "left", vertical: "top" }}
      options={menuItems}
    >
      {({ handleOpenMenu }) => (
        <IconButton onClick={handleOpenMenu} IconComponent={MoreHorizIcon} />
      )}
    </Menu>
  );
};
